module.exports = __webpack_public_path__ + "static/Kavya_N-e44d6e54478142eacf7d00fe7614e261.jpeg";